import UserProfile from 'components/UserProfile';

export default {
  path: 'profile',
  component: UserProfile
};
